export enum VideoDownloadIcons {
    AutoDownload,
    FoundationDownload
}